import './Header.scss';

import * as React from 'react';
import { Link } from 'gatsby';

import * as Core from 'components/core';
import Logo from 'components/Logo';
import ContentWrapper from 'components/ContentWrapper';

type Props = {
  backLinkText?: string;
  backLinkTo?: string;
};

export default function Header(props: Props) {
  return (
    <ContentWrapper>
      <header className="Header">
        <div className="Header-main">
          <Link to="/" className="Header-main-logo">
            <Logo includeHover />
          </Link>
          <nav role="navigation" className="Header-main-navigation">
            <div className="Header-main-navigation-link --btn">
              <Link to="/videos">
                Videos
              </Link>
            </div>
            <div className="Header-main-navigation-link">
              <Link to="/guide">
                Guide
              </Link>
            </div>
            <div className="Header-main-navigation-link">
              <Link to="/blog">
                Blog
              </Link>
            </div>
            <div className="Header-main-navigation-link">
              <Link to="/guide/about-xoxo">
                About XOXO
              </Link>
            </div>
          </nav>
        </div>
        {props.backLinkTo && (
          <Link to={props.backLinkTo}>
            <div className="Header-linkBack">
              <div className="Header-linkBack-icon">
                <Core.IconArrow />
              </div>
              <div className="Header-linkBack-label">
                {props.backLinkText}
              </div>
            </div>
          </Link>
        )}
      </header>
    </ContentWrapper>
  );
}
